/**
 * extractApiError — універсальна обробка axios-помилок з FastAPI.
 *
 * Покриває 3 формати поля `detail`:
 *   - string (стандартний HTTPException)
 *   - array  (Pydantic 422 validation: [{loc, msg, type}, ...])
 *   - object (нестандартний {code, message})
 *
 * Захищає від `[object Object]` у alert() і від «білої сторінки»
 * при неочікуваному форматі.
 */
import type { AxiosError } from 'axios';

export function extractApiError(e: unknown, fallback = 'Помилка'): string {
  if (!e) return fallback;

  const err = e as AxiosError<{ detail?: unknown }>;
  const detail = err.response?.data?.detail;

  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    return (
      detail
        .map((d) => {
          const obj = d as { loc?: unknown[]; msg?: string; type?: string };
          const field = Array.isArray(obj.loc) ? obj.loc.slice(-1).join('') : '';
          return field
            ? `${field}: ${obj.msg ?? obj.type ?? 'invalid'}`
            : (obj.msg ?? '');
        })
        .filter(Boolean)
        .join('; ') || fallback
    );
  }

  if (detail && typeof detail === 'object') {
    try {
      return JSON.stringify(detail);
    } catch {
      return fallback;
    }
  }

  return err.message || fallback;
}
